import {
  List
} from 'immutable';

import {
  BTOBS_FETCH
} from '../constants/ActionTypes';

const initialState = new List();
export default (state = initialState, action) => {
  switch (action.type) {
    case BTOBS_FETCH: {
      return action.payload;
    }
    default:
      return state;
  }
};
